import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "aim-rent-admin-view-all";

export function useAdminView() {
  const [enabled, setEnabledState] = useState(false);

  // Hydrate from localStorage on mount
  useEffect(() => {
    if (typeof window === "undefined") return;
    setEnabledState(window.localStorage.getItem(STORAGE_KEY) === "1");
  }, []);

  const setEnabled = useCallback((v: boolean) => {
    setEnabledState(v);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, v ? "1" : "0");
    }
  }, []);

  return { enabled, setEnabled };
}

/** Append ?all=true (or & if other params already present) when admin-view is ON. */
export function withAllOwners(url: string, enabled: boolean): string {
  if (!enabled) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}all=true`;
}
